import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import DemoSectionView from "../DemoVideoView/DemoVideoView.js";
import "./TractionView.css";

function TractionView() {
  return (
    <div className="TestimonialsView background-primary">
      <Container maxWidth="xl">
        <div
          className="testimonials-container"
          style={{
            padding: "3rem 0rem",
          }}
        >
          <Grid container>
            <Grid item sm={12} md={5}>
              <div style={{ padding: "0rem 3rem" }}>
                <div
                  className="text-heading"
                  style={{
                    textAlign: "left",
                    paddingBottom: "3rem",
                    paddingTop: "1rem",
                  }}
                >
                  Photorealistic demos{" "}
                  <span style={{ opacity: "0.5" }}>
                    built right into your storefront.
                  </span>
                </div>
                <div
                  className="text-heading"
                  style={{ textAlign: "left", paddingBottom: "3rem" }}
                >
                  Captivate your customers{" "}
                  <span style={{ opacity: "0.5" }}>
                    and increase conversions by up to 71%.
                  </span>
                </div>
              </div>
            </Grid>
            <Grid item sm={12} md={7}>
              <DemoSectionView />
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
}

export default TractionView;
